import { parsePhoneNumber } from 'awesome-phonenumber';

export const isPhoneNumberValid = (phoneNumber: string) => {
  const o = parsePhoneNumber(phoneNumber, { regionCode: 'US' });
  return o.valid;
};

export const formatPhoneNumber = (phoneNumber: string): string => {
  const digitsOnly = `${phoneNumber}`.replace(/\D/g, '');
  const matches = digitsOnly.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (matches) {
    const intlCode = matches[1] ? '+1 ' : '';
    return `${intlCode}(${matches[2]}) ${matches[3]}-${matches[4]}`;
  }

  return '';
};

export const removeWhitespaces = (phoneNumber: string): string => {
  return phoneNumber.replace(/\s/g, '');
};
